import { IFormHandler } from "./forms";
import { convertAmountToFloat } from "../helpers/transaction_helpers";
import { IBudget } from "../config/budget";

export interface IBudgetForm {
    name: string;
    amount: string;
}

export interface IBudgetRequest {
    name: string;
    amount: number;
}

export class BudgetForm implements IFormHandler<IBudgetForm, IBudgetRequest> {
    public readonly initialValue: IBudgetForm;

    constructor(data?: IBudget) {
        this.initialValue = this.toForm(data);
    }

    toForm(data?: IBudgetRequest): IBudgetForm {
        if (!data) {
            return {
                name: '',
                amount: '',
            };
        }

        return {
            name: data.name,
            amount: data.amount.toString(),
        };
    }

    toRequest(data: IBudgetForm): IBudgetRequest {
        return {
            name: data.name,
            amount: convertAmountToFloat(data.amount),
        };
    }
}
